const DEVICE_ID_KEY = "siki-web-device-id";

export const getOrCreateDeviceId = () => {
  if (typeof window === "undefined") {
    return "server";
  }
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      if (crypto?.randomUUID) {
        id = crypto.randomUUID();
      } else {
        id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      }
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch (e) {
    return `${Date.now()}`;
  }
};
